import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { ERROR_GRAPH__base } from '../../_errors/ERROR_GRAPH__base';
import { ERROR_GRAPH__node } from '../../_errors/ERROR_GRAPH__node';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { INVOCATION__base } from './INVOCATION__base';

declare module './INVOCATION__base' {
  interface INVOCATION__base {
    validate(graph: DTO_GRAPH__instance): void;

    error_add(error_type: ENUM__error_type): ERROR_GRAPH__base;

    error_add__field(field: FIELD__base, error_type: ENUM__error_type): ERROR_GRAPH__base;
  }
}

export function INIT_EXTENSION_INVOCATION__base__validation() {
  // do nothing
}

// if some node is stub and not is_optional and not getting value from other node return false
// if value is not stub and assert_standard_fields passed -> return true
INVOCATION__base.prototype.validate = function (graph: DTO_GRAPH__instance) {
  if (this.meta.is_validated) return;
  this.meta.is_validated = true;

  // let fields_all = this.get_fields_map(true).values();

  for (let field of Object.values(this)) {
    if (!(field instanceof FIELD__base)) continue;

    field.validate(graph);
  }

  let errors_from_fields: ERROR_GRAPH__base[] = [];

  let fields_all = this.get_fields_map(true).values();

  for (let field of fields_all) errors_from_fields = [...errors_from_fields, ...field.meta.errors];

  if (!errors_from_fields.is_empty()) this.error_add(ENUM__error_type.GRAPH_NODE__CONTAINS_FIELDS_WITH_ERRORS);

  // for (const field of fields_all) {
  //   field.validate(graph);

  //   // if connected filed is input -> just check field value, because we copied all values from another input
  //   // if connected filed is internal -> wrong case
  //   // todo: need to check field on another node
  // }

  let nodes_incomers = graph.nodes__get_map_incomers(this, false).values();

  for (let node_incomer of nodes_incomers) {
    node_incomer.validate(graph);

    if (node_incomer.meta.errors.is_empty()) continue;

    this.error_add(ENUM__error_type.GRAPH_NODE__CONNECTED_TO_NODE_WITH_ERROR);

    break;
  }

  this.meta.errors = ERROR_GRAPH__base.get_unique(this.meta.errors);
};

INVOCATION__base.prototype.error_add = function (error_type: ENUM__error_type) {
  let out = ERROR_GRAPH__node.create(error_type, this.meta.node_id);

  this.meta.errors.push(out);

  return out;
};

INVOCATION__base.prototype.error_add__field = function (field: FIELD__base, error_type: ENUM__error_type) {
  let out = field.error_add(error_type);

  this.meta.errors.push(out);

  return out;
};
